<div class="whole-container">
    <div class="top-section-container">
        <div class="top-section container">
            <div class="back-icon-container">
                <mat-icon (click)="goBack()" class="back-icon">arrow_back</mat-icon>
                <p class="category-heading title font-poppins">{{ category || productCategories.All }}</p>
            </div>
            <p class="heading-text font-inter">Discover amazing toy blocks and sets for endless creativity</p>
        </div>
    </div>

    <div class="bottom-section-container">
        <div class="bottom-section container">
            <div class="filter-section" *ngIf="isOpenFilter">
                <div class="filter-section-heading">
                    <span class="filters font-poppins">Filters</span>
                    <span class="clear" *ngIf="selectedSubCategories.length" (click)="clearFilterItems()"
                        >Clear All</span
                    >
                </div>

                @if (category !== productCategories.BuyBlocks) {
                    <div class="separator"></div>
                }

                <!-- filter section -->
                <div
                    class="sub-category-section"
                    *ngIf="availableSubCategories.length && !searchQuery && category !== productCategories.BuyBlocks"
                >
                    <div class="sub-category-heading">
                        <span>Sub Categories</span>
                    </div>

                    <!-- subCategory section -->
                    <div class="subCategories">
                        @for (subCategory of availableSubCategories; track subCategory; let i = $index) {
                        <div
                            class="subCategory font-inter"
                            [ngClass]="{ isActive: isActiveSubCategory(subCategory!) }"
                            (click)="selectSubCategory(subCategory!)"
                        >
                            <span>{{ subCategory }}</span>
                        </div>
                        }
                    </div>
                </div>

                @if (category !== productCategories.BuyBlocks) {
                    <div class="separator"></div>
                }

                <!-- Price Range -->
                <div class="price-range-section">
                    <div class="price-section-heading">
                        <p class="price-section-title">Price Range</p>
                    </div>

                    <div class="price-section">
                        <span class="currency font-inter">Min Price(₹)</span>
                        <input type="number" placeholder="Min" [(ngModel)]="minPrice" (blur)="onBlur($event, true)" />
                        <span class="currency font-inter">Max Price(₹)</span>
                        <input type="number" placeholder="Max" [(ngModel)]="maxPrice" (blur)="onBlur($event, false)" />
                    </div>

                    <button class="apply" (click)="applyPriceFilter()">Apply Filter</button>
                </div>
            </div>

            <div class="product-section">
                <div class="product-section-top">
                    <div class="filter-btn-products-found-container">
                        <button mat-raised-button class="save-btn filter-btn" (click)="toggleFilterButton()">
                            <mat-icon>tune</mat-icon> Filter
                        </button>
                        <span class="products-found font-inter"
                            ><span>{{ totalProducts }}</span> Products Found</span
                        >
                    </div>

                    <div class="price-sort">
                        <mat-form-field class="box-outline dense-3 input-border-radius" appearance="outline" subscriptSizing="dynamic">
                            <mat-select
                                class="sort-select-trigger"
                                panelClass="sort-select-panel"
                                [(value)]="selectedSort"
                                (selectionChange)="onPriceSortingChange($event)"
                                placeholder="Sort by Popularity"
                            >
                                <mat-select-trigger>
                                    {{ sortLabel }}
                                </mat-select-trigger>
                                <mat-option value="hightolow">{{
                                    "productList.label.priceHighToLow" | translate
                                }}</mat-option>
                                <mat-option value="lowtohigh">{{
                                    "productList.label.priceLowToHigh" | translate
                                }}</mat-option>
                                <mat-option value="highestRated">Highest Rated</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="product-section-bottom-container">
                    <mat-spinner *ngIf="isLoading" class="loading-spinner" [diameter]="50"></mat-spinner>
                    <div class="filtering-data">
                        @for (item of selectedSubCategories; track $index) {
                        <p class="filter-item">
                            {{ item }}&nbsp;&nbsp;<mat-icon class="close-icon" (click)="removeFilterItem(item)"
                                >close</mat-icon
                            >
                        </p>
                        }
                    </div>
                    <div
                        class="product-section-bottom"
                        *ngIf="productList.length > 0; else noProducts"
                        [ngClass]="{ showList: isListView }"
                    >
                        @for (product of productList; let i = $index; track i) {
                        <app-product-card
                            [product]="product"
                            [imageBgClass]="'product-image-gradient' + ((i % 3) + 1)"
                        ></app-product-card>
                        }
                    </div>
                </div>

                <div *ngIf="this.totalProducts - this.productList.length > 0" class="btn-content">
                    <button class="view-more" variant="hero" *ngIf="!isLoading" (click)="onViewMoreClick()">
                        {{ "homePage.button.viewMoreBtn" | translate }}
                    </button>
                </div>

                <div class="right-navbar" *ngIf="isNavbarOpen">
                    <app-right-navbar (closeEvent)="onCloseNavbar()"></app-right-navbar>
                </div>

                <ng-template #noProducts>
                    <div class="no-products-wrapper" *ngIf="!isLoading">
                        <div class="no-products-card">
                            <!-- icon -->
                            <div class="icon-wrapper">
                                <mat-icon [svgIcon]="'noproduct'" class="icon1"></mat-icon>
                                <mat-icon [svgIcon]="'search'" class="icon2"></mat-icon>
                            </div>

                            <div class="content">
                                <!-- title -->
                                <span>No Product Found</span>
                                <!-- description -->
                                <p>
                                    Oops! This product doesn’t exist.
                                    <br />
                                    Start exploring toys for your little one!.
                                </p>
                                <br />
                                <button (click)="goBack()">← Back to Products</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
